import React from 'react';

import ModalConfirm from '../../shared/Modal/ModalConfirm';
import ModalNotification from './ModalNotification';
import ModalPasswordResetHistory from './ModalPasswordResetHistory';
import AddEditStore from './store';
import ModalChangePassword from './ModalChangePassword';

function AddEditModal() {
  const { modalType } = AddEditStore.modalParams;
  if (modalType === 'confirm') {
    return <ModalConfirm {...AddEditStore} onCancel={AddEditStore.toggleModal(false)} />;
  }
  if (modalType === 'notification') {
    return <ModalNotification {...AddEditStore} onCancel={AddEditStore.toggleModal(false)} />;
  }
  if (modalType === 'passwordRsHistory') {
    return <ModalPasswordResetHistory onCancel={AddEditStore.toggleModal(false)} />;
  }
  if (modalType === 'changePassword') {
    return <ModalChangePassword onCancel={AddEditStore.toggleModal(false)} />;
  }
}

export default AddEditModal;
